import { types } from 'mobx-state-tree';
import CheckboxFilterModel from './CheckboxFilterModel';

const CollapsibleOptionsModel = types
    .model('CollapsibleOptions', {
        type: types.literal('CollapsibleCheckbox'),
        collapsedOptionValues: types.array(types.string),
    })
    .views(self => ({
        get collapsedOptions() {
            return self.options.filter(option => self.collapsedOptionValues.includes(option.value));
        },
        get hasSelectedExpandedOptions() {
            return self.selectedOptions.some(option => !self.collapsedOptions.includes(option));
        },
    }));

const CollapsibleCheckboxFilterModel = types
    .compose(
        CheckboxFilterModel,
        CollapsibleOptionsModel
    )
    .named('CollapsibleCheckboxFilter');

export default CollapsibleCheckboxFilterModel;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/models/CollapsibleCheckboxFilterModel.js